import { render, staticRenderFns } from "./updateDialog.vue?vue&type=template&id=37fbe082"
import script from "./updateDialog.vue?vue&type=script&lang=js"
export * from "./updateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports